import React from "react";
import { CommandBarButton, useDisclosure, useNotifications } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../../../../core/security/SprintAccessRight";
import { useCloudFileDetails } from "../../../../common/useCloudFileDetails";
import { ApproveCloudFileDetailsNotificationsDialog } from "./ApproveCloudFileDetailsNotificationsDialog";
import { useApproveCloudFileNotifications } from "./useApproveCloudFileNotifications";

export const ApproveCloudFileDetailsNotificationsButton = (): JSX.Element => {
    const { data: cloudFileDetails } = useCloudFileDetails();

    const { approveCloudFileNotifications } = useApproveCloudFileNotifications({
        invalidationKey: cloudFileDetails?.cloudFileId
    });

    const { success, error } = useNotifications();

    const { isOpen, onClose, onOpen } = useDisclosure();

    if (!cloudFileDetails) {
        return <></>;
    }

    const handleConfirmation = async () => {
        try {
            await approveCloudFileNotifications.mutateAsync({ cloudFileId: cloudFileDetails.cloudFileId });

            success("Buzz notifications approved");
        } catch (e) {
            error("Notifications approve failed");
        }

        onClose();
    };

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.CiReadWrite]}>
            <CommandBarButton
                text={"Approve notifications"}
                icon={"CheckboxComposite"}
                onClick={onOpen}
                disabled={!!cloudFileDetails.isNotificationApproved}
            />
            <ApproveCloudFileDetailsNotificationsDialog
                confirm={handleConfirmation}
                isOpen={isOpen}
                onClose={onClose}
            />
        </AuthorizationWrapper>
    );
};
